export default "__VITE_ASSET__DqCNmmcf__"